<template>
  <div>
    <div class="detial-cont-title">申请表单</div>
    <blank height="1"> </blank>
    <div class="detial-cont-view">
      <a-descriptions layout="vertical">
        <a-descriptions-item>
          <span slot="label">购置单位<span class="required">*</span> </span>
          <a-tooltip placement="topLeft" :title="Form.organizationName">
            <div>
              <a-input
                v-if="Form.id"
                class="w300"
                placeholder="请添加"
                v-model="Form.organizationName"
                disabled
              />
              <a-select
                v-else
                class="w300"
                placeholder="请选择"
                v-model="Form.organizationId"
                :disabled="disabled"
              >
                <a-select-option
                  v-for="item in organizationUserList"
                  :value="item.organizationId"
                  :key="item.organizationId"
                >
                  {{ item.organizationname }}</a-select-option
                >
              </a-select>
            </div>
          </a-tooltip>
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">资产名称<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入资产名称"
            v-model="Form.assetsname"
            @change="emitDataFn('assetsname', 85)"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">规格型号<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入规格型号"
            v-model="Form.model"
            @change="emitDataFn('model', 85)"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">数量<span class="required">*</span> </span>
          <a-input-number
            class="w300"
            :min="0"
            :max="999999999"
            placeholder="请输入数量"
            v-model="Form.numbers"
            @change="emitDataFn()"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label"
            >预算金额（金额单位：元）<span class="required">*</span>
          </span>
          <a-input-number
            :min="0"
            :max="99999999999999999999"
            class="w300"
            placeholder="请输入预算金额"
            v-model="Form.amount"
            @change="emitDataFn()"
            @blur="emitDataFnBlur"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item label="备注">
          <a-input
            class="w300"
            placeholder="请输入备注"
            v-model="Form.note"
            @change="emitDataFn('note', 200)"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item label="购置理由">
          <a-input
            class="w500"
            placeholder="请输入购置理由"
            v-model="Form.reason"
            type="textarea"
            @change="emitDataFn('reason', 200)"
            :auto-size="{ minRows: 4, maxRows: 6 }"
            :disabled="disabled"
          />
        </a-descriptions-item>
      </a-descriptions>
    </div>
  </div>
</template>
<script>
import { getTreeList } from '../api/api'
import { mapState, mapActions } from 'vuex'
export default {
  props: ['disabled', 'resData', 'submitParams'],
  model: {
    prop: 'submitParams',
    event: 'input'
  },
  data() {
    return {
      Form: {}
    }
  },
  computed: {
    ...mapState({
      organizationUserList: (state) => state.app.organizationUserList // 当前用户可选部门
    })
  },
  methods: {
    ...mapActions(['getorganizationUserList']),
    handleChange(value) {
      this.emitDataFn()
    },
    // 传值给父组件
    emitDataFn(v, maxNum) {
      if (v) {
        this.eightyfive(v, maxNum)
      }
      this.$emit('input', this.Form)
    },
    emitDataFnBlur() {
      if (!this.Form.amount) return
      let n = this.Form.amount.toFixed(2)
      this.Form.amount = n
      this.$emit('input', this.Form)
    },
    // 输入框限制85
    eightyfive(v, maxNum) {
      if (this.Form[v].length > maxNum) {
        this.Form[v] = this.Form[v].substring(0, maxNum)
        this.$message.destroy()
        this.$message.warning('只能输入' + maxNum + '个字')
      }
    }
  },
  watch: {
    resData(val) {
      this.Form = this.resData
    }
  },
  mounted() {
    //获取组织机构
    this.getorganizationUserList()
    if (this.resData) {
      this.Form = this.resData
    }
  }
}
</script>
<style scoped lang="scss">
.detial-cont-title {
  background: #fff;
  height: 55px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  line-height: 55px;
  text-align: left;
  padding-left: 32px;
}
.detial-cont-view {
  background: #fff;
  padding: 30px;
  .accessory-btn {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.detial-bottom {
  height: 56px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/views/FixedAssets/components/procerementDetailForm.vue